module.exports = __webpack_public_path__ + "img/plano-vip-gold.52760db2.png";